'use client'

import { createContext, type ReactNode, use } from 'react'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'

import type { LayoutMobileMenuNavigationValue } from '../hooks/useLayoutMobileMenuNavigation'

const LayoutMobileMenuNavigationContext = createContext<LayoutMobileMenuNavigationValue | null>(null)

export function useLayoutMobileMenuNavigationContext() {
  const context = use(LayoutMobileMenuNavigationContext)
  if (!context) {
    throw new Error('useLayoutMobileMenuNavigationContext must be used within LayoutMobileMenuNavigationProvider')
  }
  return context
}

export function useOptionalLayoutMobileMenuNavigation() {
  return use(LayoutMobileMenuNavigationContext)
}

type LayoutMobileMenuNavigationProviderProps = {
  children: ReactNode
  value: LayoutMobileMenuNavigationValue
}

export function LayoutMobileMenuNavigationProvider({ children, value }: LayoutMobileMenuNavigationProviderProps) {
  return (
    <LayoutMobileMenuNavigationContext value={value}>
      <div data-testid={LAYOUT_TEST_IDS.layoutMobileMenuNavigationProvider} style={{ display: 'contents' }}>
        {children}
      </div>
    </LayoutMobileMenuNavigationContext>
  )
}
